<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MaMarkdownEditor',
})
</script>
<template>
	<div class="markdown-editor">
		<MdEditor
			v-model="content"
			style="height: 100%"
			:placeholder="props.placeholder"
			:disabled="props.disabled"
			:show-toolbar-name="true"
			:toolbars-exclude="[]"
			:preview="true"
			:editor-id="editorId"
			@on-upload-img="handleUploadImg"
			@on-html-changed="onHtmlChanged"
			@on-change="onChange"
			@on-save="onSave"
		/>
	</div>
</template>

<script lang="ts" setup name="MaMarkdownEditor">
import { ref, watch, defineExpose } from 'vue'
import { MdEditor } from 'md-editor-v3'
import 'md-editor-v3/lib/style.css'
import constant from '@/utils/constant'
import cache from '@/utils/cache'

const props = defineProps({
	modelValue: {
		type: String,
		default: ''
	},
	height: {
		type: String,
		default: '400px'
	},
	placeholder: {
		type: String,
		default: '请输入markdown内容...'
	},
	disabled: {
		type: Boolean,
		default: false
	}
})

const emit = defineEmits(['update:modelValue', 'change', 'save'])
const content = ref(props.modelValue)
const editorId = `md-editor-v3-${Math.random().toString(36).substr(2, 9)}`

// 图片上传
const handleUploadImg = async (files: File[], callback: (urls: string[]) => void) => {
	const urls: string[] = []
	for (const file of files) {
		const formData = new FormData()
		formData.append('file', file)
		try {
			const res = await fetch(constant.uploadUrl + '?access_token=' + cache.getToken(), {
				method: 'POST',
				body: formData
			})
			const data = await res.json()
			if (data.code === 0) {
				urls.push(constant.apiUrl + data.data.url)
			}
		} catch (e) {
			// 可根据需要处理错误
		}
	}
	callback(urls)
}

// 内容变化
const onChange = (value: string) => {
	emit('update:modelValue', value)
	emit('change', value)
}

// html变化（可选）
const onHtmlChanged = (html: string) => {
	// 可根据需要处理html变化
}

const onSave = (value: string, html: Promise<string>) => {
	html.then((h: string) => {
		console.log(value, h)
		emit('save', value, h)
	})
}

// 监听外部modelValue变化
watch(
	() => props.modelValue,
	newValue => {
		if (newValue !== content.value) {
			content.value = newValue
		}
	}
)

// 监听内部内容变化
watch(content, val => {
	if (val !== props.modelValue) {
		emit('update:modelValue', val)
	}
})

// 锚点跳转
const scrollToAnchor = (anchorId: string) => {
	const targetElement = document.getElementById(anchorId)
	if (targetElement) {
		targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
		targetElement.style.backgroundColor = '#fff3cd'
		setTimeout(() => {
			targetElement.style.backgroundColor = ''
		}, 2000)
	}
}

// 暴露方法
defineExpose({
	getValue: () => content.value,
	getHtml: () => {
		// md-editor-v3没有直接getHTML方法，如有需要可用marked等库转换
		return ''
	},
	setValue: (value: string) => {
		content.value = value
	},
	insertValue: (value: string) => {
		content.value += value
	},
	scrollToAnchor
})
</script>

<style lang="scss" scoped>
.markdown-editor {
	width: 100%;
	height: 100%;
}
</style>
